import { createFileRoute, redirect } from '@tanstack/react-router'

import { getUIVersion } from 'lib/uiVersion'

import SettingsLayout from 'pages/Settings/SettingsLayout'

export const Route = createFileRoute('/_auth/settings')({
  beforeLoad: ({ context }) => {
    if (getUIVersion() === 'classic') {
      throw redirect({ to: context.auth.routing.home || '/' })
    }
  },
  component: SettingsLayout,
})
